import { View, Text, TouchableOpacity, StyleSheet } from 'react-native'
import { fonts } from '../lib/theme'
import { useThemeColors } from '../lib/useThemeColors'
import { hapticLight } from '../lib/haptics'

// Schede dell'app, un solo componente per tutte (prima c'erano quattro copie leggermente diverse).
//   variant 'pill'      : contenitore grigio con la scheda attiva piena nel colore del brand (Tappa/Generale, Inserimento/Riepilogo...)
//   variant 'underline' : testo con una linea sotto la scheda attiva (le schede principali di una pagina)
// Accessibilita': il contenitore e' una tablist, ogni scheda ha ruolo 'tab' e stato 'selected'; altezza minima 44 pt.
// options: [{ key, label }]
export default function SegmentedTabs({ options, value, onChange, variant = 'pill', uppercase = true, style, label }) {
  const tc = useThemeColors()
  const underline = variant === 'underline'
  return (
    <View
      style={[underline ? s.underlineRow : s.pillRow, underline ? { borderBottomColor: tc.border } : { backgroundColor: tc.bgCard2 }, style]}
      accessibilityRole="tablist"
      accessibilityLabel={label}
    >
      {options.map(o => {
        const on = o.key === value
        return (
          <TouchableOpacity
            key={o.key}
            onPress={() => { if (!on) { hapticLight(); onChange(o.key) } }}
            activeOpacity={0.7}
            accessibilityRole="tab"
            accessibilityState={{ selected: on }}
            accessibilityLabel={o.label}
            style={underline
              ? [s.underlineBtn, { borderBottomColor: on ? tc.rosa : 'transparent' }]
              : [s.pillBtn, on && { backgroundColor: tc.rosa }]}
          >
            <Text
              numberOfLines={1}
              style={[
                s.text,
                uppercase && { textTransform: 'uppercase' },
                { color: on ? (underline ? tc.rosaText : tc.brandText) : tc.textMuted },
              ]}
            >
              {o.label}
            </Text>
          </TouchableOpacity>
        )
      })}
    </View>
  )
}

const s = StyleSheet.create({
  pillRow: { flexDirection: 'row', borderRadius: 10, padding: 3, gap: 3 },
  pillBtn: { flex: 1, minHeight: 44, paddingHorizontal: 8, alignItems: 'center', justifyContent: 'center', borderRadius: 8 },
  underlineRow: { flexDirection: 'row', borderBottomWidth: 1 },
  underlineBtn: { minHeight: 44, paddingHorizontal: 16, alignItems: 'center', justifyContent: 'center', borderBottomWidth: 2, marginBottom: -1 },
  text: { fontFamily: fonts.condensedBold, fontSize: 13, letterSpacing: 0.5 },
})
